// extracted by mini-css-extract-plugin
export default {"problem":"QyfoB"};